import React from 'react';
import './styles.scss';

const Index = () => {
  return (
    <footer className="footer">
      &copy; ПАО &laquo;СИБУР Холдинг&raquo; 2018. Все права защищены.
    </footer>
  );
};

export default Index;
